/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var d = require("prismjs");

require("prismjs/components/prism-clike");

require("prismjs/components/prism-javascript");

require("prismjs/components/prism-markup");

require("prismjs/components/prism-markdown");

require("prismjs/components/prism-c");

require("prismjs/components/prism-css");

require("prismjs/components/prism-objectivec");

require("prismjs/components/prism-sql");

require("prismjs/components/prism-python");

require("prismjs/components/prism-rust");

require("prismjs/components/prism-swift");

require("prismjs/components/prism-typescript");

require("prismjs/components/prism-java");

require("prismjs/components/prism-cpp");

var l = require("@lexical/utils"),
    r = require("lexical");

var v = function v(a) {
  return null != a && d.languages.hasOwnProperty(a) ? a : void 0;
};

function x(a, b) {
  var _iterator = _createForOfIteratorHelper(a.childNodes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var c = _step.value;
      if (l.isHTMLElement(c) && c.tagName === b) return !0;
      x(c, b);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return !1;
}

var y = /*#__PURE__*/function (_r$ElementNode) {
  _inherits(y, _r$ElementNode);

  var _super = _createSuper(y);

  function y(a, b) {
    var _this;

    _classCallCheck(this, y);

    _this = _super.call(this, b);
    _this.__language = v(a);
    return _this;
  }

  _createClass(y, [{
    key: "createDOM",
    value: function createDOM(a) {
      var b = document.createElement("code");
      l.addClassNamesToElement(b, a.theme.code);
      b.setAttribute("spellcheck", "false");
      (a = this.getLanguage()) && b.setAttribute("data-highlight-language", a);
      return b;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM(a, b) {
      var c = this.__language;
      a = a.__language;
      c ? c !== a && b.setAttribute("data-highlight-language", c) : a && b.removeAttribute("data-highlight-language");
      return !1;
    }
  }, {
    key: "exportDOM",
    value: function exportDOM() {
      var a = document.createElement("pre");
      a.setAttribute("spellcheck", "false");
      var b = this.getLanguage();
      b && a.setAttribute("data-highlight-language", b);
      return {
        element: a
      };
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(y.prototype), "exportJSON", this).call(this)), {}, {
        language: this.getLanguage(),
        type: "code",
        version: 1
      });
    }
  }, {
    key: "insertNewAfter",
    value: function insertNewAfter(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var c = this.getChildren(),
          e = c.length;
      if (2 <= e && "\n" === c[e - 1].getTextContent() && "\n" === c[e - 2].getTextContent() && a.isCollapsed() && a.anchor.key === this.__key && a.anchor.offset === e) return c[e - 1].remove(), c[e - 2].remove(), a = r.$createParagraphNode(), this.insertAfter(a, b), a;
      b = a.anchor;
      c = a.focus;
      b = (b.isBefore(c) ? b : c).getNode();

      if (D(b) || r.$isTabNode(b)) {
        b = E(b);

        for (c = [];;) {
          if (r.$isTabNode(b)) c.push(r.$createTabNode()), b = b.getNextSibling();else if (D(b)) {
            e = 0;
            var f = b.getTextContent(),
                g = b.getTextContentSize();

            for (; e < g && " " === f[e]; e++) {
              ;
            }

            0 !== e && c.push(F(" ".repeat(e)));
            if (e !== g) break;
            b = b.getNextSibling();
          } else break;
        }

        if (0 < c.length) return a.insertNodes([r.$createLineBreakNode()].concat(_toConsumableArray(c))), c[c.length - 1];
      }

      return null;
    }
  }, {
    key: "canIndent",
    value: function canIndent() {
      return !1;
    }
  }, {
    key: "collapseAtStart",
    value: function collapseAtStart() {
      var a = r.$createParagraphNode();
      this.getChildren().forEach(function (b) {
        return a.append(b);
      });
      this.replace(a);
      return !0;
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(a) {
      this.getWritable().__language = v(a);
    }
  }, {
    key: "getLanguage",
    value: function getLanguage() {
      return this.getLatest().__language;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "code";
    }
  }, {
    key: "clone",
    value: function clone(a) {
      return new y(a.__language, a.__key);
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        code: function code(a) {
          return null != a.textContent && (/\r?\n/.test(a.textContent) || x(a, "BR")) ? {
            conversion: z,
            priority: 1
          } : null;
        },
        div: function div() {
          return {
            conversion: aa,
            priority: 1
          };
        },
        pre: function pre() {
          return {
            conversion: z,
            priority: 0
          };
        },
        table: function table(a) {
          return A(a) ? {
            conversion: ba,
            priority: 3
          } : null;
        },
        td: function td(a) {
          var b = a.closest("table");
          return a.classList.contains("js-file-line") ? {
            conversion: ca,
            priority: 3
          } : b && A(b) ? {
            conversion: B,
            priority: 3
          } : null;
        },
        tr: function tr(a) {
          return (a = a.closest("table")) && A(a) ? {
            conversion: B,
            priority: 3
          } : null;
        }
      };
    }
  }, {
    key: "importJSON",
    value: function importJSON(a) {
      var b = C(a.language);
      b.setFormat(a.format);
      b.setIndent(a.indent);
      b.setDirection(a.direction);
      return b;
    }
  }]);

  return y;
}(r.ElementNode);

function C(a) {
  return r.$applyNodeReplacement(new y(a));
}

function G(a) {
  return a instanceof y;
}

function z(a) {
  var b;
  l.isHTMLElement(a) && (b = a.getAttribute("data-highlight-language"));
  return {
    node: C(b)
  };
}

function aa(a) {
  var b = null !== a.style.fontFamily.match("monospace");
  return b || da(a) ? {
    after: function after(c) {
      var e = a.parentNode;
      null != e && a !== e.lastChild && c.push(r.$createLineBreakNode());
      return c;
    },
    node: b ? C() : null
  } : {
    node: null
  };
}

function ba() {
  return {
    node: C()
  };
}

function B() {
  return {
    node: null
  };
}

function ca(a) {
  return {
    after: function after(b) {
      a.parentNode && a.parentNode.nextSibling && b.push(r.$createLineBreakNode());
      return b;
    },
    node: null
  };
}

function da(a) {
  for (a = a.parentElement; null !== a;) {
    if (null !== a.style.fontFamily.match("monospace")) return !0;
    a = a.parentElement;
  }

  return !1;
}

function A(a) {
  return a.classList.contains("js-file-line-container");
}

var H = {
  c: "C",
  clike: "C-like",
  cpp: "C++",
  css: "CSS",
  html: "HTML",
  java: "Java",
  js: "JavaScript",
  markdown: "Markdown",
  objc: "Objective-C",
  plain: "Plain Text",
  py: "Python",
  rust: "Rust",
  sql: "SQL",
  swift: "Swift",
  typescript: "TypeScript",
  xml: "XML"
},
    I = {
  cpp: "cpp",
  java: "java",
  javascript: "js",
  md: "markdown",
  plaintext: "plain",
  python: "py",
  text: "plain",
  ts: "typescript"
};

function K(a) {
  return I[a] || a;
}

var L = /*#__PURE__*/function (_r$TextNode) {
  _inherits(L, _r$TextNode);

  var _super2 = _createSuper(L);

  function L(a, b, c) {
    var _this2;

    _classCallCheck(this, L);

    _this2 = _super2.call(this, a, c);
    _this2.__highlightType = b;
    return _this2;
  }

  _createClass(L, [{
    key: "getHighlightType",
    value: function getHighlightType() {
      return this.getLatest().__highlightType;
    }
  }, {
    key: "createDOM",
    value: function createDOM(a) {
      var b = _get(_getPrototypeOf(L.prototype), "createDOM", this).call(this, a);

      a = M(a.theme, this.__highlightType);
      l.addClassNamesToElement(b, a);
      return b;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM(a, b, c) {
      var e = _get(_getPrototypeOf(L.prototype), "updateDOM", this).call(this, a, b, c);

      a = M(c.theme, a.__highlightType);
      c = M(c.theme, this.__highlightType);
      a !== c && (a && l.removeClassNamesFromElement(b, a), c && l.addClassNamesToElement(b, c));
      return e;
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(L.prototype), "exportJSON", this).call(this)), {}, {
        highlightType: this.getHighlightType(),
        type: "code-highlight",
        version: 1
      });
    }
  }, {
    key: "setFormat",
    value: function setFormat() {
      return this;
    }
  }, {
    key: "isParentRequired",
    value: function isParentRequired() {
      return !0;
    }
  }, {
    key: "createParentElementNode",
    value: function createParentElementNode() {
      return C();
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "code-highlight";
    }
  }, {
    key: "clone",
    value: function clone(a) {
      return new L(a.__text, a.__highlightType || void 0, a.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(a) {
      var b = F(a.text, a.highlightType);
      b.setFormat(a.format);
      b.setDetail(a.detail);
      b.setMode(a.mode);
      b.setStyle(a.style);
      return b;
    }
  }]);

  return L;
}(r.TextNode);

function M(a, b) {
  return b && a && a.codeHighlight && a.codeHighlight[b];
}

function F(a, b) {
  return r.$applyNodeReplacement(new L(a, b));
}

function D(a) {
  return a instanceof L;
}

function E(a) {
  var b = a;

  for (; D(a) || r.$isTabNode(a);) {
    b = a, a = a.getPreviousSibling();
  }

  return b;
}

function N(a) {
  var b = a;

  for (; D(a) || r.$isTabNode(a);) {
    b = a, a = a.getNextSibling();
  }

  return b;
}

var O = {
  defaultLanguage: "javascript",
  tokenize: function tokenize(a, b) {
    return d.tokenize(a, d.languages[b || ""] || d.languages[this.defaultLanguage]);
  }
};

function P(a, b) {
  var c = null;
  var e = null,
      f = a;
  var g = b,
      h = a.getTextContent();

  for (;;) {
    if (0 === g) {
      f = f.getPreviousSibling();
      if (null === f) break;
      if (!(D(f) || r.$isTabNode(f) || r.$isLineBreakNode(f))) throw Error("Expected a valid Code Node: CodeHighlightNode, TabNode, LineBreakNode");

      if (r.$isLineBreakNode(f)) {
        c = {
          node: f,
          offset: 1
        };
        break;
      }

      g = Math.max(0, f.getTextContentSize() - 1);
      h = f.getTextContent();
    } else g--;

    var k = h[g];
    D(f) && " " !== k && (e = {
      node: f,
      offset: g
    });
  }

  if (null !== e) return e;
  e = null;
  b < a.getTextContentSize() ? D(a) && (e = a.getTextContent()[b]) : (f = a.getNextSibling(), D(f) && (e = f.getTextContent()[0]));
  if (null !== e && " " !== e) return c;

  a: for (e = a, f = a.getTextContent(), a = a.getTextContentSize();;) {
    if (!D(e) || b === a) {
      e = e.getNextSibling();

      if (null === e || r.$isLineBreakNode(e)) {
        a = null;
        break a;
      }

      D(e) && (b = 0, f = e.getTextContent(), a = e.getTextContentSize());
    }

    if (D(e)) {
      if (" " !== f[b]) {
        a = {
          node: e,
          offset: b
        };
        break a;
      }

      b++;
    }
  }

  return null !== a ? a : c;
}

function Q(a) {
  a = N(a);
  if (r.$isLineBreakNode(a)) throw Error("Unexpected lineBreakNode in getEndOfCodeInLine");
  return a;
}

function R(a, b, c) {
  var e = a.getParent();
  G(e) ? S(e, b, c) : D(a) && a.replace(r.$createTextNode(a.__text));
}

var T = new Set();

function S(a, b, c) {
  var e = a.getKey();
  T.has(e) || (T.add(e), void 0 === a.getLanguage() && a.setLanguage(c.defaultLanguage), b.update(function () {
    ea(e, function () {
      var f = r.$getNodeByKey(e);
      if (!G(f) || !f.isAttached()) return !1;
      var g = f.getTextContent();
      g = c.tokenize(g, f.getLanguage() || c.defaultLanguage);
      g = U(g);
      var h = f.getChildren();

      for (f = 0; f < h.length && V(h[f], g[f]);) {
        f++;
      }

      var k = h.length;
      var m = g.length,
          q = Math.min(k, m) - f,
          n = 0;

      for (; n < q;) {
        if (n++, !V(h[k - n], g[m - n])) {
          n--;
          break;
        }
      }

      h = f;
      k -= n;
      g = g.slice(f, m - n);
      var _from$nodesForReplace = {
        from: h,
        nodesForReplacement: g,
        to: k
      },
          p = _from$nodesForReplace.from,
          w = _from$nodesForReplace.to,
          u = _from$nodesForReplace.nodesForReplacement;
      return p !== w || u.length ? (a.splice(p, w - p, u), !0) : !1;
    });
  }, {
    onUpdate: function onUpdate() {
      T.delete(e);
    },
    skipTransforms: !0
  }));
}

function U(a, b) {
  var c = [];

  var _iterator2 = _createForOfIteratorHelper(a),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _e;

      var e = _step2.value;

      if ("string" === typeof e) {
        a = e.split(/(\n|\t)/);
        var f = a.length;

        for (var g = 0; g < f; g++) {
          var h = a[g];
          "\n" === h || "\r\n" === h ? c.push(r.$createLineBreakNode()) : "\t" === h ? c.push(r.$createTabNode()) : 0 < h.length && c.push(F(h, b));
        }
      } else (_e = e, a = _e.content, _e), "string" === typeof a ? c.push.apply(c, _toConsumableArray(U([a], e.type))) : Array.isArray(a) && c.push.apply(c, _toConsumableArray(U(a, e.type)));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return c;
}

function ea(a, b) {
  a = r.$getNodeByKey(a);

  if (G(a) && a.isAttached()) {
    var c = r.$getSelection();

    if (r.$isRangeSelection(c)) {
      c = c.anchor;
      var e = c.offset,
          f = "element" === c.type && r.$isLineBreakNode(a.getChildAtIndex(c.offset - 1)),
          g = 0;

      if (!f) {
        var h = c.getNode();
        g = e + h.getPreviousSiblings().reduce(function (k, m) {
          return k + m.getTextContentSize();
        }, 0);
      }

      b() && (f ? c.getNode().select(e, e) : a.getChildren().some(function (h) {
        var k = r.$isTextNode(h);

        if (k || r.$isLineBreakNode(h)) {
          var m = h.getTextContentSize();
          if (k && m >= g) return h.select(g, g), !0;
          g -= m;
        }

        return !1;
      }));
    } else b();
  }
}

function V(a, b) {
  return D(a) && D(b) && a.__text === b.__text && a.__highlightType === b.__highlightType || r.$isTabNode(a) && r.$isTabNode(b) || r.$isLineBreakNode(a) && r.$isLineBreakNode(b);
}

function W(a) {
  if (!r.$isRangeSelection(a)) return !1;
  var b = a.anchor.getNode();
  a = a.focus.getNode();
  if (b.is(a) && G(b)) return !0;
  b = b.getParent();
  return G(b) && b.is(a.getParent());
}

function X(a) {
  a = a.getNodes();
  var b = [[]];
  if (1 === a.length && G(a[0])) return b;
  var c = b[0];

  for (var e = 0; e < a.length; e++) {
    var f = a[e];
    if (!(D(f) || r.$isTabNode(f) || r.$isLineBreakNode(f))) throw Error("Expected selection to be inside CodeBlock and consisting of CodeHighlightNode, TabNode and LineBreakNode");
    r.$isLineBreakNode(f) ? 0 !== e && 0 < c.length && (c = [], b.push(c)) : c.push(f);
  }

  return b;
}

function fa(a) {
  var b = r.$getSelection();
  if (!r.$isRangeSelection(b) || !W(b)) return null;
  var c = a ? r.OUTDENT_CONTENT_COMMAND : r.INDENT_CONTENT_COMMAND;
  a = a ? r.OUTDENT_CONTENT_COMMAND : r.INSERT_TAB_COMMAND;
  if (1 < X(b).length) return c;
  var e = b.getNodes()[0];
  if (!(G(e) || D(e) || r.$isTabNode(e) || r.$isLineBreakNode(e))) throw Error("Expected selection firstNode to be CodeHighlightNode or TabNode");
  if (G(e)) return c;
  var f = E(e);
  e = N(e);
  var g = b.anchor;
  var h = b.focus;
  h.isBefore(g) ? b = h : (b = g, g = h);
  return null !== f && null !== e && b.key === f.getKey() && 0 === b.offset && g.key === e.getKey() && g.offset === e.getTextContentSize() ? c : a;
}

function Y(a) {
  var b = r.$getSelection();
  if (!r.$isRangeSelection(b) || !W(b)) return !1;
  var c = X(b);
  var e = c.length;

  if (1 < c.length) {
    for (b = 0; b < e; b++) {
      var f = c[b];
      0 < f.length && (f = f[0], 0 === b && (f = E(f)), null !== f && (a === r.INDENT_CONTENT_COMMAND ? f.insertBefore(r.$createTabNode()) : r.$isTabNode(f) && f.remove()));
    }

    return !0;
  }

  c = b.getNodes()[0];
  if (!(G(c) || D(c) || r.$isTabNode(c) || r.$isLineBreakNode(c))) throw Error("Expected selection firstNode to be CodeHighlightNode or CodeTabNode");
  if (G(c)) return a === r.INDENT_CONTENT_COMMAND && b.insertNodes([r.$createTabNode()]), !0;
  c = E(c);
  if (null === c) throw Error("Expected getFirstCodeNodeOfLine to return a valid Code Node");
  a === r.INDENT_CONTENT_COMMAND ? r.$isLineBreakNode(c) ? c.insertAfter(r.$createTabNode()) : c.insertBefore(r.$createTabNode()) : r.$isTabNode(c) && c.remove();
  return !0;
}

function Z(a, b) {
  var c = r.$getSelection();
  if (!r.$isRangeSelection(c)) return !1;
  var e = c.anchor,
      f = c.focus,
      g = e.offset,
      h = f.offset,
      k = e.getNode(),
      m = f.getNode();
  var q = a === r.KEY_ARROW_UP_COMMAND;
  if (!W(c) || !D(k) && !r.$isTabNode(k) || !D(m) && !r.$isTabNode(m)) return !1;

  if (!b.altKey) {
    if (c.isCollapsed()) if (a = k.getParentOrThrow(), q && 0 === g && null === k.getPreviousSibling()) {
      if (null === a.getPreviousSibling()) return a.selectPrevious(), b.preventDefault(), !0;
    } else if (!q && g === k.getTextContentSize() && null === k.getNextSibling() && null === a.getNextSibling()) return a.selectNext(), b.preventDefault(), !0;
    return !1;
  }

  var n;

  if (k.isBefore(m)) {
    var p = E(k);
    n = N(m);
  } else p = E(m), n = N(k);

  if (null == p || null == n) return !1;
  var w = p.getNodesBetween(n);

  for (var t = 0; t < w.length; t++) {
    var J = w[t];
    if (!D(J) && !r.$isTabNode(J) && !r.$isLineBreakNode(J)) return !1;
  }

  b.preventDefault();
  b.stopPropagation();
  b = q ? p.getPreviousSibling() : n.getNextSibling();
  if (!r.$isLineBreakNode(b)) return !0;
  p = q ? b.getPreviousSibling() : b.getNextSibling();
  if (null == p) return !0;
  q = D(p) || r.$isTabNode(p) || r.$isLineBreakNode(p) ? q ? E(p) : N(p) : null;
  var u = null != q ? q : p;
  b.remove();
  w.forEach(function (t) {
    return t.remove();
  });
  a === r.KEY_ARROW_UP_COMMAND ? (w.forEach(function (t) {
    return u.insertBefore(t);
  }), u.insertBefore(b)) : (u.insertAfter(b), u = b, w.forEach(function (t) {
    u.insertAfter(t);
    u = t;
  }));
  c.setTextNodeRange(k, g, m, h);
  return !0;
}

function ha(a, b) {
  var c = r.$getSelection();
  if (!r.$isRangeSelection(c)) return !1;
  var e = c.anchor,
      f = c.focus;
  var g = e.getNode();
  var h = f.getNode();
  a = a === r.MOVE_TO_START;
  if (!D(g) && !r.$isTabNode(g) || !D(h) && !r.$isTabNode(h)) return !1;
  if (a) {
    if (g = P(h, f.offset), null !== g) {
      var _g = g,
          k = _g.node,
          m = _g.offset;
      r.$isLineBreakNode(k) ? k.selectNext(0, 0) : c.setTextNodeRange(k, m, k, m);
    } else h.getParentOrThrow().selectStart();
  } else Q(h).select();
  b.preventDefault();
  b.stopPropagation();
  return !0;
}

exports.$createCodeHighlightNode = F;
exports.$createCodeNode = C;
exports.$isCodeHighlightNode = D;
exports.$isCodeNode = G;
exports.CODE_LANGUAGE_FRIENDLY_NAME_MAP = H;
exports.CODE_LANGUAGE_MAP = I;
exports.CodeHighlightNode = L;
exports.CodeNode = y;
exports.DEFAULT_CODE_LANGUAGE = "javascript";
exports.PrismTokenizer = O;

exports.getCodeLanguages = function () {
  return Object.keys(d.languages).filter(function (a) {
    return "function" !== typeof d.languages[a];
  }).sort();
};

exports.getDefaultCodeLanguage = function () {
  return "javascript";
};

exports.getEndOfCodeInLine = Q;
exports.getFirstCodeNodeOfLine = E;

exports.getLanguageFriendlyName = function (a) {
  a = K(a);
  return H[a] || a;
};

exports.getLastCodeNodeOfLine = N;
exports.getStartOfCodeInLine = P;
exports.normalizeCodeLang = K;

exports.registerCodeHighlighting = function (a, b) {
  if (!a.hasNodes([y, L])) throw Error("CodeHighlightPlugin: CodeNode or CodeHighlightNode not registered on editor");
  null == b && (b = O);
  return l.mergeRegister(a.registerMutationListener(y, function (c) {
    a.update(function () {
      var _iterator3 = _createForOfIteratorHelper(c),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ref3 = _step3.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var g = _ref2[0];
          var h = _ref2[1];

          if ("destroyed" !== h) {
            var e = r.$getNodeByKey(g);
            if (null !== e) a: {
              var f = e;
              e = a.getElementByKey(f.getKey());
              if (null === e) break a;
              f = f.getChildren();
              var k = f.length;
              if (k === e.__cachedChildrenLength) break a;
              e.__cachedChildrenLength = k;
              var m = "1",
                  q = 1;

              for (var n = 0; n < k; n++) {
                r.$isLineBreakNode(f[n]) && (m += "\n" + ++q);
              }

              e.setAttribute("data-gutter", m);
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    });
  }), a.registerNodeTransform(y, function (c) {
    return S(c, a, b);
  }), a.registerNodeTransform(r.TextNode, function (c) {
    return R(c, a, b);
  }), a.registerNodeTransform(L, function (c) {
    return R(c, a, b);
  }), a.registerCommand(r.KEY_TAB_COMMAND, function (c) {
    var e = fa(c.shiftKey);
    if (null === e) return !1;
    c.preventDefault();
    a.dispatchCommand(e, void 0);
    return !0;
  }, r.COMMAND_PRIORITY_LOW), a.registerCommand(r.INSERT_TAB_COMMAND, function () {
    var c = r.$getSelection();
    if (!W(c)) return !1;
    r.$insertNodes([r.$createTabNode()]);
    return !0;
  }, r.COMMAND_PRIORITY_LOW), a.registerCommand(r.INDENT_CONTENT_COMMAND, function () {
    return Y(r.INDENT_CONTENT_COMMAND);
  }, r.COMMAND_PRIORITY_LOW), a.registerCommand(r.OUTDENT_CONTENT_COMMAND, function () {
    return Y(r.OUTDENT_CONTENT_COMMAND);
  }, r.COMMAND_PRIORITY_LOW), a.registerCommand(r.KEY_ARROW_UP_COMMAND, function (c) {
    return Z(r.KEY_ARROW_UP_COMMAND, c);
  }, r.COMMAND_PRIORITY_LOW), a.registerCommand(r.KEY_ARROW_DOWN_COMMAND, function (c) {
    return Z(r.KEY_ARROW_DOWN_COMMAND, c);
  }, r.COMMAND_PRIORITY_LOW), a.registerCommand(r.MOVE_TO_END, function (c) {
    return ha(r.MOVE_TO_END, c);
  }, r.COMMAND_PRIORITY_LOW), a.registerCommand(r.MOVE_TO_START, function (c) {
    return ha(r.MOVE_TO_START, c);
  }, r.COMMAND_PRIORITY_LOW));
};